/*
 * localStorage sometimes isn't available for candidates, which leads
 * to them being unable to submit their interview! We'll proxy to memoryStorage
 * so they're at least able to submit if they've not refreshed the page...
 */
const memoryStorage = {};

const getLocalStorage = () => {
  try {
    if (typeof window === 'undefined') {
      return null;
    }
    return window.localStorage || null;
  } catch (error) {
    return null;
  }
};

const setItem = (key, value) => {
  memoryStorage[key] = value;
  const localStorageRef = getLocalStorage();
  if (!localStorageRef) {
    return;
  }
  try {
    localStorageRef.setItem(key, value);
  } catch (error) {
    // localStorage can throw in restricted/private modes; memoryStorage is fallback.
  }
};

const getItem = (key) => {
  if(memoryStorage.hasOwnProperty(key)) {
    return memoryStorage[key];
  }
  const localStorageRef = getLocalStorage();
  if (!localStorageRef) {
    return null;
  }
  try {
    return localStorageRef.getItem(key);
  } catch (error) {
    return null;
  }
};

const removeItem = (key) => {
  delete memoryStorage[key];
  const localStorageRef = getLocalStorage();
  if (!localStorageRef) {
    return;
  }
  try {
    localStorageRef.removeItem(key);
  } catch (error) {
    // Ignore remove failures when localStorage isn't writable.
  }
};

const storage = { setItem, getItem, removeItem };

export default storage;
